import {
  PACKAGEProducts,
  initialPACKAGEProducts,
  packagecolumnToPropertyMapping,
  packageColumnsV2,
  packageColumnsV1
} from './package.model';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
type AOA = Array<Array<string | number>>;

export class PACKAGEControl {
  constructor(data: AOA, activePortal: string) {
    this.setRawData(data);
    this.apiRequest = [];
    this.activePortal = activePortal;

  }
  /**
   * @method getEndpoint get the packages api
   */
  public get getEndpoint() {
    return this.activePortal === 'svppv2' ? environment.ProductCatalog.apis.packagev2 : environment.ProductCatalog.apis.package;
  }
  /**
  * @method getApitype returns api type
  * @returns object
  **/
  public get getApiType(): object {
    return { type: 'package' };
  }
  /**
  * @arg SVPPColumns to store the svpp constant headings
  **/
  public static SVPPColumns: Array<string> = [];
  /**
* @arg packageProduct to store an packages product
**/
  private packageProduct: PACKAGEProducts;
  /**
* @arg packageRequest to store package api request
**/
  private apiRequest: Array<PACKAGEProducts>;
  /**
  * @arg tableData to store table data
  **/
  private tableData: Array<any>;
  /**
  * @arg titles to store raw titles from the raw data
  **/
  private titles: Array<string>;
  /**
  * @arg values to store raw values from the raw data
  **/
  private values: AOA;
  /**
   *@arg activePortal active portal stores whether it's svpp or svppv2 or admin or dealer-admin or navi
   **/
  public activePortal: string;
  /**
  * @method checkColumns checks if the columns have the required fields until the column description
  * @param columns columns of the raw data
  **/
  public static checkColumns(columns: Array<string>): boolean {
    let validData = true;
    PACKAGEControl.SVPPColumns = window.location.pathname.includes('svppv2') ? packageColumnsV2 : packageColumnsV1;
    columns.slice(0, 14).forEach(column => {
      if (!(PACKAGEControl.SVPPColumns.indexOf(column.trim()) > -1)) {
        validData = false;
      }
    });
    return validData;
  }
  /**
  * @method setRawData sets the raw data to the model
  * @param data data to be set
  **/
  private setRawData(data: AOA): void {
    const columns = data[0] as Array<string>;
    this.titles = columns;
    this.values = data.splice(1);
  }
  /**
  * @method convertToRequest converts the raw data to the api request format
  **/
  private convertToRequest(): void {
    for (let row = 0; row < this.values.length; row++) {
      const rowData = this.values[row];
      if (rowData.length === this.titles.length) {
        this.parseRow(rowData);
      }
    }
  }
  /**
  * @method parseRow parses row data to pacakges product
  * @param rowData rowdata
  **/
  private parseRow(rowData: Array<string | number>): void {
    this.resetProducts();
    for (let index = 0; index < rowData.length; index++) {
      this.setPackageDetails(index, rowData[index]);
    }
    this.setPackageRequest();
  }
  /**
  * @method convertToTable converts the raw data to table format
  **/
  private convertToTable(): void {
    this.tableData = [];
    if (this.titles.indexOf('TAGS') > -1) {
      for (let row = 0; row < this.values.length; row++) {
        if (this.values[row].length < this.titles.length) {
          this.values[row].push('');
        }
      }
    }
    for (let row = 0; row < this.values.length; row++) {
      const tableRow = {};
      const rowData = this.values[row];
      for (let index = 0; index < rowData.length; index++) {
        tableRow[this.titles[index]] = rowData[index];
      }
      this.tableData.push(tableRow);
    }
  }
  /**
  * @method resetProducts resets the packages product
  **/
  private resetProducts(): void {
    const clone = JSON.stringify(initialPACKAGEProducts);
    const defaultPackage = JSON.parse(clone);
    this.packageProduct = defaultPackage;
  }
  /**
  * @method setPackageRequest sets the api request
  **/
  private setPackageRequest(): void {
    this.apiRequest.push(this.packageProduct);
  }

  /**
   * @method setApiRequest sets the api request
   **/
  private setApiRequest(): void {
    this.apiRequest.push(this.packageProduct);
  }
  /**
  * @method setPackageDetails sets the asi details (not the capabilities)
  * @param index column index
  * @param value value to be stored
  **/
  public setPackageDetails(index, value): void {
    if (this.titles[index] != 'TAGS') {
      this.packageProduct[this.getProperty(index)] = `${value}`;
    } else if (this.titles[index] === 'TAGS' && ( !!!value || value.split(',')[0] === '')) {
      delete this.packageProduct['Tags'];
    } else {
      const tagsValue = [];
      value.split(',').forEach(element => {
        tagsValue.push(element.trim());
      });
      this.packageProduct[this.getProperty(index)] = tagsValue;
    }
  }
  /**
  * @method getProperty gets the property keys for the api request from the columntoProperty mapping
  * @param index column index
  **/
  private getProperty(index): string {
    return packagecolumnToPropertyMapping[this.titles[index]];
  }
  /**
  * @method getApiRequest returns the api request
  **/
  public getApiRequest(): Array<PACKAGEProducts> {
    this.convertToRequest();
    return this.apiRequest;
  }
  /**
  * @method getColumns returns the column names
  **/
  public getColumns(): Array<string> {
    return this.titles;
  }
  /**
  * @method getTableData returns the table
  **/
  public getTableData(): Array<object> {
    this.convertToTable();
    return this.tableData;
  }
}
